import styled from "styled-components";

import slider_background from "../../image/slider_background.svg";
import slider_button_main from "../../image/slider_button_main.svg";
import slider_extra from "../../image/slider_button_extra.svg";

const StyledContainer = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 19px;
  background: #fff;
  border-radius: 12px;
  box-shadow:
    0 4px 17px 0 rgba(0, 0, 0, 0.04),
    0 4px 4px 0 rgba(0, 0, 0, 0.25),
    0 14px 24px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 24px;
  width: 359px;

  h3 {
    border-bottom: 1px solid #c9c8c8;
    color: #1e1919;
    font-size: 17px;
    font-weight: 300;
    line-height: 18px;
    margin: unset;
    padding-bottom: 10px;
    text-align: center;
  }

  .ant-slider {
    margin: 14px 0;

    .ant-slider-track {
      background: unset;
      height: 11px;
      cursor: default;
    }

    .ant-slider-rail {
      background: url("${slider_background}") center;
      background-size: cover;
      height: 11px;
      cursor: default;

      &::before {
        content: "";
        border-left: 2px solid #8c8c8c;
        height: 26px;
        left: 0;
        position: absolute;
        top: -7px;
      }

      &::after {
        content: "";
        border-left: 2px solid #8c8c8c;
        height: 26px;
        position: absolute;
        right: 0;
        top: -7px;
      }
    }

    .ant-slider-handle {
      box-shadow: unset;
      z-index: 1;

      &::before {
        background: url("${slider_button_main}") center no-repeat;
        background-size: cover;
        height: 32px;
        left: -15px;
        top: -8px;
        width: 32px;
        z-index: 2;
      }

      &::after {
        background: url("${slider_extra}") center no-repeat;
        background-size: cover;
        border-radius: 8px;
        box-shadow: unset;
        height: 11px;
        left: -48px;
        outline: unset;
        top: 3px;
        width: 96px;
        z-index: 1;
      }
    }
  }

  h4 {
    font-size: 26px;
    font-weight: 300;
    line-height: 1;
    margin: unset;
  }

  .container-value {
    align-items: center;
    background: rgba(234, 244, 244, 0.5);
    border-radius: 8px;
    color: #000;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;
    padding: 16px;
    text-align: center;

    p {
      margin: unset;
    }

    h5 {
      font-size: 21px;
      margin: unset;
    }
  }
`;

export default StyledContainer;
